import $ from 'jquery'
import { flamegraph, defaultFlamegraphTooltip } from 'd3-flame-graph'
import * as d3 from 'd3'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='liquid-profile']").each(function () {
    const $this = $(this)
    const profileData = JSON.parse($this.text())

    const entryDuration = (d) => (d.data.value * 1000).toFixed(2)
    const entryLabel = (d) => d.data.name + ' (' + entryDuration(d) + ' ms)'
    const entryTooltip = defaultFlamegraphTooltip().html((d) => entryLabel(d))

    const graphId = 'liquid-flamegraph'
    const graph = flamegraph()
      .inverted(true)
      .minFrameSize(4)
      .cellHeight(20)
      .width($this.parent().width())

    graph.label(entryLabel)
    graph.tooltip(entryTooltip)

    $this.after(`
    <div class="liquid-profiler-container">
      <div id="${graphId}"></div>
    </div>
    `)

    d3.select(`#${graphId}`).datum(profileData).call(graph)
  })
})
